export default {
  id: 6,
  pride: 7168,
  slug: "challengers-odyssey",
  portfolioKind: "study",
  category: "game",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "挑战之旅",
    en: "Challenger's Odyssey"
  },
  image: require('@/assets/images/co_header.webp'),
  descriptionKey: {
    zh: "2024年本科毕设，ARPG+大模型AI游戏，单人制作。不推荐游玩。",
    en: "2024 undergraduate graduation project, ARPG + LLM AI game, solo production. Not recommended for play."
  },
  date: { year: 2024, month: 2, day: 9 },
  genres: ["ARPG", "AI"],
  themes: ["挑战"],
  engine: "虚幻引擎 5.3",
  platform: ["PC"],
  roles: {
    zh: "单人制作",
    en: "Solo Developer"
  },
  achievements: [
    { zh: "300 人玩过", en: "Played by 300 people" }
  ],
  developerNotesKey: {
    zh: "毕设，ARPG+大模型AI游戏，单人制作。免费上架steam，300人玩过，有人评价挺好玩的。不推荐游玩。",
    en: "Graduation project, ARPG + LLM AI game, solo production. Released for free on Steam, played by 300 people, some reviewed it as quite fun. Not recommended for play."
  },
  tags: ["LLM", "AI大世界尝试"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "steam", url: "https://store.steampowered.com/app/2778690/Challengers_Odyssey/", textKey: { zh: "Steam 商店", en: "Steam Store" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1pkvye1EXL/", textKey: { zh: "毕设AI NPC演示", en: "Graduation Project AI NPC Demo" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1zH4y1Y76S/", textKey: { zh: "上Steam了！", en: "Now on Steam!" } }
  ]
};
